import { useEffect, useState } from "react";
import "./assets/NewsList.css";
import { apiClient } from "./services/ApiClient";

import NewsData from "./services/newsData";
import { Box, Container, Grid, Typography } from "@mui/material";
import TopNewsItem from "./components/TopNewsItem";
import NewsItem from "./components/NewsItem";
import NewsItemLoading from "./components/loading/NewsItemLoading";
import TopNewsLoading from "./components/loading/TopNewsLoading";

function App() {
  const [news, setNews] = useState(null);
  const [topNews, setTopNews] = useState(null);
  const [loading, setLoading] = useState(true);

  const getNews = async () => {
    setLoading(true);

    const res = await apiClient
      .get("news/all")
      .catch((error) => console.error(error));

    const sortedData = [];

    for (const key in res.data) {
      if (res.data.hasOwnProperty(key)) {
        sortedData.push(res.data[key]);
      }
    }

    sortedData.reverse();

    const newsData = sortedData.filter((item) => item.news.istopnews !== 1);

    setNews(newsData);

    const topNews = sortedData.filter((item) => item.news.istopnews === 1);

    setTopNews(topNews);

    setLoading(false);
  };

  useEffect(() => {
    getNews();
  }, []);

  if (loading) {
    return (
      <Container
        maxWidth="xl"
        sx={{
          maxWidth: "1700px !important",
          pl: { md: "80px !important", sm: "24px !important" },
          pr: { md: "80px !important", sm: "24px !important" },
          mt: "4%",
          mb: "4%",
        }}
      >
        <TopNewsLoading />
        <Grid container spacing={6} sx={{ mt: 4 }}>
          <NewsItemLoading />
          <NewsItemLoading />
          <NewsItemLoading />
          <NewsItemLoading />
          <NewsItemLoading />
          <NewsItemLoading />
          <NewsItemLoading />
          <NewsItemLoading />
          <NewsItemLoading />
        </Grid>
      </Container>
    );
  }

  return (
    <Container
      maxWidth="xl"
      sx={{
        maxWidth: "1700px !important",
        pl: { md: "80px !important", sm: "24px !important" },
        pr: { md: "80px !important", sm: "24px !important" },
        mt: "4%",
        mb: "4%",
      }}
    >
      <TopNewsItem data={topNews} />
      <Grid container spacing={6} sx={{ mt: 4 }}>
        {news.length !== 0 &&
          news.map((item, index) => (
            <NewsItem key={"news-item-" + index} data={item} />
          ))}
      </Grid>
    </Container>
  );
}

export default App;
